import { useContext, useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

import { AuthContext } from "../services/contexts/AuthContext";
import { useCurrency } from "../services/contexts/CurrencyContext";
import { GAME, isPromoted } from "../utils/christmasGame";
import { Sparkle } from "./Doodles";
import "../styles/header.css";

const ADMIN_EMAIL = "stamsy.art@abv.bg";

const openChat = () => {
    if (window.Tawk_API && window.Tawk_API.maximize) window.Tawk_API.maximize();
};

export const Header = () => {
    const { user } = useContext(AuthContext);
    const { currency, toggleCurrency } = useCurrency();
    const username = localStorage.getItem('username');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();

    // Менюто на телефона се затваря при всяка смяна на страницата
    useEffect(() => setIsMenuOpen(false), [location.pathname]);

    // Щом страницата тръгне надолу, хедърът получава блур и сянка — иначе
    // кремавият фон се слива със страницата и редът увисва върху текста.
    useEffect(() => {
        const onScroll = () => setIsScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const isLoggedIn = Boolean(user && user.email);
    const isAdmin = isLoggedIn && user.email === ADMIN_EMAIL;
    const navClass = ({ isActive }) => `sa-nav-link${isActive ? ' is-active' : ''}`;

    return (
        <header className={`sa-header${isScrolled ? ' is-scrolled' : ''}${isAdmin ? ' is-admin' : ''}`}>
            <div className="sa-header-row">
                {/* Логото е марка, не заглавие — всяка страница си има свое <h1>. */}
                <Link to="/" className="sa-logo" aria-label="Stamsy Art — начало">
                    <span className="sa-logo-name">
                        Stamsy Art
                        <Sparkle size={16} className="sa-logo-star sa-twinkle" />
                    </span>
                    <span className="sa-logo-tag">рисувано с любов</span>
                </Link>

                <button
                    type="button"
                    className={`sa-burger${isMenuOpen ? ' is-open' : ''}`}
                    onClick={() => setIsMenuOpen(open => !open)}
                    aria-expanded={isMenuOpen}
                    aria-controls="sa-nav"
                    aria-label={isMenuOpen ? "Затвори менюто" : "Отвори менюто"}
                >
                    <span /><span /><span />
                </button>

                <nav id="sa-nav" className={`sa-nav${isMenuOpen ? ' is-open' : ''}`} aria-label="Основно меню">
                    <div className="sa-nav-links">
                        <NavLink to="/" end className={navClass}>Начало</NavLink>
                        <NavLink to="/catalog" className={navClass}>Каталог</NavLink>
                        <NavLink to="/blog" className={navClass}>Полезно</NavLink>
                        <NavLink to="/about" className={navClass}>За нас</NavLink>
                        {isPromoted(Date.now()) && (
                            <NavLink to={GAME.path} className={({ isActive }) => `${navClass({ isActive })} sa-nav-xmas`}>
                                🎄 Коледна игра
                            </NavLink>
                        )}
                        {isAdmin && (
                            <>
                                <NavLink to="/add" className={navClass}>Добави продукт</NavLink>
                                <NavLink to="/orders" className={navClass}>Поръчки</NavLink>
                            </>
                        )}
                        {isLoggedIn && !isAdmin && (
                            <NavLink to="/my-orders" className={navClass}>Моите поръчки</NavLink>
                        )}
                    </div>

                    <div className="sa-nav-tools">
                        <button type="button" onClick={toggleCurrency} className="sa-currency" title="Смени валутата">
                            {currency === 'EUR' ? '€ → лв' : 'лв → €'}
                        </button>
                        {isLoggedIn ? (
                            <>
                                <span className="sa-nav-user">{username || user.email}</span>
                                <Link to="/logout" className="sa-nav-link sa-nav-link--quiet">Изход</Link>
                            </>
                        ) : (
                            <>
                                <Link to="/login" className="sa-nav-link sa-nav-link--quiet">Вход</Link>
                                <Link to="/register" className="sa-nav-link sa-nav-link--quiet">Регистрация</Link>
                            </>
                        )}
                        <button type="button" className="sa-btn sa-btn--primary sa-btn--sm sa-header-cta" onClick={openChat}>
                            Пиши ни
                        </button>
                    </div>
                </nav>
            </div>
        </header>
    );
};
